<template>
    <div>
        <ModalCommon :id="`DownloadDataCampaign`" :config="modalConfig" @save="onHanleDownload()" @close="onHandleClose()">
            <div v-if="isLoading" class="d-flex justify-content-center align-items-center">
                <div>
                    <LoadingIcon class="d-flex justify-content-center align-items-center" />
                    <div class="mt-2">
                        <h5 class="text-center py-3">処理中です。少々お待ちください。</h5>
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">{{ $t('pageCampaign.downloadType') }}</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(itemType, idx) in TYPE_EXPORT" :key="itemType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="export_type"
                                :name="`campaignExportType`"
                                :id="`${idx}`"
                                :value="itemType.value"
                                :label="itemType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="table-responsive" style="height: calc(100vh - 150px - 121px)">
                    <table class="table table-bordered table-box">
                        <thead>
                            <th class="sticky__export--campaign">
                                <InputCheckBox
                                    :model.sync="checkedAll"
                                    :id="`checkedAllTableList`"
                                    :value="checkedAll"
                                    :label="``"
                                    @change="onHandleCheckAllRecord"
                                />
                            </th>
                            <th class="sticky__export--campaign">{{ $t('pageCampaign.indexDownloadData') }}</th>
                            <th class="sticky__export--campaign">{{ $t('pageCampaign.descriptionDownloadData') }}</th>
                        </thead>
                        <tbody>
                            <template v-for="(itemList, idx) in needItemDown">
                                <template v-if="['0'].includes(itemList.id)">
                                    <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                        <td class="colOne"></td>
                                        <td class="colTwo">
                                            <div class="text-left">
                                                {{ itemData.title }}
                                            </div>
                                        </td>
                                        <td class="text-left colThree">
                                            <div class="row-data-large text-wrap">
                                                {{ itemData.description }}
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr :key="`${idx}`">
                                        <td :colspan="3" class="p-0">
                                            <table class="table table-bordered table-box mb-0">
                                                <tr :style="`background-color:${itemList.backgroundColor}`">
                                                    <td class="colOne">
                                                        <InputCheckBox
                                                            :model.sync="itemList.check"
                                                            :id="`check-down${itemList.id}`"
                                                            :value="itemList.check"
                                                            :label="``"
                                                            @change="onHandleCheckItem"
                                                        />
                                                    </td>
                                                    <td class="colTwo">
                                                        <div class="text-left" style="margin-top: 0.16rem">
                                                            {{ itemList.title }}
                                                        </div>
                                                    </td>
                                                    <td class="text-left colThree"></td>
                                                </tr>
                                            </table>
                                            <table class="table table-bordered table-box mb-0">
                                                <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                                    <td class="colOne"></td>
                                                    <td class="colTwo">
                                                        <div class="text-left">
                                                            {{ itemData.title }}
                                                        </div>
                                                    </td>
                                                    <td class="text-left colThree">
                                                        <div class="row-data-large text-wrap" v-html="convertNtoBr(itemData.description)"></div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { InputCheckBox, InputRadio } from '@/components/Input';
import { NEED_ITEM_DOWNLOAD, convertNtoBr, TYPE_EXPORT } from './constants';
import { campaignMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { handleDownFile } from '@/utils/format';

export default {
    name: 'DownloadDataCampaign',
    components: {
        ModalCommon,
        InputCheckBox,
        InputRadio,
        LoadingIcon
    },
    props: {
        modalConfig: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            needItemDown: NEED_ITEM_DOWNLOAD(),
            TYPE_EXPORT,
            checkedAll: false,
            export_type: TYPE_EXPORT[0].value,
            isLoading: false
        };
    },
    methods: {
        ...campaignMethods,

        convertNtoBr,
        async onHanleDownload() {
            const listIDChecked = this.needItemDown.filter((item) => item.check && item.large_key_down).map((item) => item.large_key_down);
            if (listIDChecked.length <= 0) {
                showMessage(400, this.$bvToast, 'ダウンロードするには、少なくとも1つ選択してください。');
                return;
            }
            let payload = {
                export_columns: listIDChecked,
                export_type: this.export_type,
                search_id: this.modalConfig.searchId
            };
            if (this.isLoading) return;
            this.isLoading = true;
            this.modalConfig.hideFooter = true;
            try {
                const dataRes = await this.downloadCampaignData(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes.code, this.$bvToast, 'ダウンロード処理が失敗しました。');
                    return;
                }
                showMessage(dataRes.code, this.$bvToast, 'ダウンロード処理が完了しました。');
                handleDownFile(dataRes.data.url, dataRes.data?.file_name || new Date().getTime());
                this.modalConfig.model = false;
            } catch (error) {
                showMessage(error.code, this.$bvToast, 'ダウンロード処理が失敗しました。');
            } finally {
                this.isLoading = false;
                this.modalConfig.hideFooter = false;
            }
        },

        onHandleClose() {
            this.modalConfig.model = false;
        },

        onHandleCheckItem() {
            const listIDChecked = this.needItemDown?.length;
            this.checkedAll = listIDChecked === this.needItemDown.filter((item) => item.check)?.length;
        },

        onHandleCheckAllRecord() {
            this.needItemDown.forEach((item) => {
                item.check = this.checkedAll;
            });
        }
    },
    watch: {
        'modalConfig.model': {
            handler: function (newCheckAll) {
                if (newCheckAll) {
                    this.export_type = TYPE_EXPORT[0].value;
                    this.checkedAll = true;
                    this.needItemDown.forEach((item) => {
                        item.check = true;
                    });
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
td {
    &.colOne {
        width: 50px;
        min-width: 50px;
        max-width: 50px;
    }
    &.colTwo {
        width: 340px;
        min-width: 340px;
        max-width: 340px;
    }
}
.sticky__export--campaign {
    text-align: left;
    position: sticky;
    background-color: #ffffff;
    top: 0;
    z-index: 20;
}
</style>
